import {Button, Grid, Typography} from "@mui/material";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Container from "../../../../../common/Container";
import {useTranslation} from "react-i18next";
import {LotItem, LotList, LotWithItemList} from "../../../../../types/lot";
import {LotModal} from "./components";
import {Company} from "../../../../../types/company";
import {AuctionState, AuctionType} from "../../../../../utils/enums";
import LotCard from "./components/LotCard";
import {AuctionLotList} from "../../../../../types/auction";
import {auctionService} from "../../../../../api/services/auction";
import {useSnack} from "../../../../../utils/useSnack";

export type LotFieldsProps = {
    company: Company | null,
    getLots: (lots: LotWithItemList[]) => void,
    auctionType: AuctionType,
    auctionState: AuctionState,
    auctionLots?: AuctionLotList[]
    auctionId?: number | null
}
export const LotFields = ({
                              company,
                              getLots,
                              auctionType,
                              auctionState,
                              auctionLots,
                              auctionId
                          }: LotFieldsProps) => {
    const {t} = useTranslation();

    const navigate = useNavigate();
    const [lots, setLots] = React.useState<any[]>([]);
    const [isNewOpen, setIsNewOpen] = React.useState(false);
    const onOpenLot = () => setIsNewOpen(true);
    const {snack} = useSnack();

    useEffect(() => {
        setLots(auctionLots || [])
    }, [auctionLots]);

    const pickLots = async (lots: LotWithItemList[]) => {
        if (!!auctionId) {
            const response = await auctionService.addLot(company!.id, auctionId, lots.map(lot => lot.id))
            try {
                if (response.status === "success" ) {
                    console.log(response.data)
                } else {
                    return
                }
            } catch (error) {
                snack(t("snack.error.default"), "error");
                return
            }
        }
        setLots(lots);
        setIsNewOpen(false);
        getLots(lots);
    }

    // Обработчики событий
    const handleAddItem = (lotId: string | number) => {
        // Логика добавления элемента
        console.log(`Добавление элемента в лот ${lotId}`);
    };

    const handleDeleteItem = async (lotId: string | number, itemId: string | number) => {

        // Логика удаления элемента
        setLots(prevLots =>
            prevLots.map(lot => {
                if (lot.id === lotId) {
                    return {
                        ...lot,
                        lotItems: lot.items.filter((item: LotItem) => item.id !== itemId)
                    };
                }
                return lot;
            })
        );
    };

    const handleDeleteLot = async (id: number, lotId?: number) => {
        // Логика удаления лота
        if (!!auctionId) {
            const response = await auctionService.deleteLot(company!.id, auctionId, +lotId!)
            try {
                if (response.status === "success") {
                    console.log(response.data)
                } else {
                    return
                }
            } catch (error) {
                snack(t("snack.error.default"), "error");
                return
            }
        }

        setLots(prevLots => prevLots.filter(lot => lot.id !== id));
    };


    return <Grid item>
        <Grid item container columnSpacing={3} rowSpacing={1} sx={{mb: 2}}>
            <Grid item>
                <Button color={"primary"} variant="contained" size="small" onClick={onOpenLot}>
                    {t("auction.lots.add_lot")}
                </Button>
            </Grid>
        </Grid>

        <LotModal isOpen={isNewOpen} onClose={() => setIsNewOpen(false)} pickLots={pickLots} company={company}
                  auctionType={auctionType} auctionState={auctionState}/>

        {lots.map(lot => (
            <LotCard
                lot={lot}
                key={lot.id}
                onAddItem={handleAddItem}
                onDeleteItem={handleDeleteItem}
                onDeleteLot={handleDeleteLot}
                maxItems={5}
            />
        ))}

    </Grid>

}